import { getAzureFilePath } from "../functions/azure"

const STATUS_ACTIVE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

const ORDER_INQUIRY_STATUS = {
  ACKNOWLEDGED: 'Acknowledged',
  PENDING: 'pending',
}

const DATA_TYPE = {
  NEWS: 'news',
  PROMOTION: 'promotion',
}

const CUSTOMER_TYPE = {
  FIXERS: {
    TYPE: 'Fixers / Contractors / Installer / Applicator',
  },
  HARDWARE: {
    TYPE: 'Hardware Store / Construction Shop',
  },
  HOMEOWNER: {
    TYPE: 'Homeowner / Project Owner',
  },
  ROLL_FORMER: {
    TYPE: 'Roll former',
  },
  OTHERS: {
    TYPE: 'Others',
  },
  AUTHORISED_DEALER: {
    TYPE: 'Authorised Dealer',
  },
  // CR: 1483
  ARCHITECT: {
    TYPE: 'Architect / Designer / Consult',
  },
  ENGINEER: {
    TYPE: 'Engineer',
  },
}

const UPLOAD_PATH = {
  IMAGE_PROFILE: '/users',
  IMAGE_CUSTOMER: '/customers',
  IMAGE_CHECK_IN: '/check-in',
  WARRANTY: '/warranty',
  DOCUMENTARY: '/documentary',
  PROJECT_DOCUMENT: '/project-document',
  LOG: '/log',
  AD_CERTIFICATE: '/ad-certificate'
}

const UPLOAD_PATH_FOLDER = {
  PROJECT_DOCUMENT_WARRANTY_TEMPLATE: '/warranty-template',
  PROJECT_DOCUMENT_CERTIFICATE: '/certificate',
  PROJECT_DOCUMENT_DOCUMENTARY: '/documentary',
  PROJECT_DOCUMENT_REFERENCE: '/reference',
}

const DOWNLOAD_PATH = {
  UPLOAD_TRANSACTION_TEMPLATE: getAzureFilePath('rbptrueblue/misc/Upload_transaction_template.csv'),
}

const CMS_TYPE = {
  TRUE_BLUE: 'trueblue',
}

const CUSTOMER_CONTACT_CHANNEL = {
  EMAIL: 'email',
  SMS: 'sms'
}

const COUNTRY = {
  THAI: 'Thailand',
  MALAYSIA: 'Malaysia',
  VIETNAM: 'Vietnam',
  INDONESIA: 'Indonesia',
  LAOS: 'Laos',
  SOUTH_AFRICA: 'South Africa'
}

const CUSTOMER_ROLE_TYPE = {
  THAI: {
    DISTRIBUTOR: 'Distributor',
  },
  MALAYSIA: {
    ROLL_FORMER: 'Roll Former',
    AD: 'Authorized Dealer',
    HARDWARE_SHOP: 'Toko',
    DISTRIBUTOR: 'Distributor',
  },
  INDONESIA: {
    DIRECT_ROLL_FORMER: 'Direct Roll Former',
    LYSAGHT_CENTER: 'Lysaght Center',
    AD: 'Authorized Dealer',
    TOKO: 'Toko',
    DISTRIBUTOR: 'Distributor',
  },
}

export const COUNTRY_TYPE = {
  THAI: 'th',
  MALAYSIA: 'ml',
  VIETNAM: 'vi',
  INDONESIA: 'in',
  LAOS: 'la',
  SOUTH_AFRICA: 'za'
}

const REWARD_STOCK_TYPE = {
  IN_STOCK: 'InStock',
  ON_DEMAND: 'On Demand',
}

const USER_ROLE = {
  OWNER: 'Owner',
  SALES_PERSON: 'Salesperson',
}

const ADMIN_ROLE = {
  TH: 'admin_th',
  ML: 'admin_ml',
  IN: 'admin_id',
  VI: 'admin_vn',
}

const PROFILE_UNIT = {
  STICK: 'stick (s)',
  SHEET: 'sheet (s)',
}

const PROFILE_TYPE_UNIT = {
  ['Truss C75-75']: PROFILE_UNIT.STICK,
  ['Truss C75-65']: PROFILE_UNIT.STICK,
  ['RengR30-45']: PROFILE_UNIT.STICK,
  ['RengR32-45']: PROFILE_UNIT.STICK,
  ['RengR35-45']: PROFILE_UNIT.STICK,
  ['RengR 30-45']: PROFILE_UNIT.STICK,
  ['RengR 32-45']: PROFILE_UNIT.STICK,
  ['RengR 35-45']: PROFILE_UNIT.STICK,
  ['Long Span 0.25 TCT']: PROFILE_UNIT.SHEET,
  ['Long Span 0.30 TCT']: PROFILE_UNIT.SHEET,
  ['Long Span 0.35 TCT']: PROFILE_UNIT.SHEET,
  ['Metal Tile 0.25 TCT']: PROFILE_UNIT.SHEET,
  ['Metal Tile 0.30 TCT']: PROFILE_UNIT.SHEET,
  ['Metal Tile 0.35 TCT']: PROFILE_UNIT.SHEET
}

const SEGMENT_BUILDING = {
  FACTORY: {
    VALUE: "Factory",
    VALUE_TH: "โรงงาน",
  },
  OFFICE: {
    VALUE: "Office",
    VALUE_TH: "สำนักงาน",
  },
  CAR_PARK: {
    VALUE: "Car park",
    VALUE_TH: "ลานจอดรถ",
  },
  WAREHOUSE: {
    VALUE: "Warehouse",
    VALUE_TH: "โกดัง",
  },
  OTHER: {
    VALUE: "Other",
    VALUE_TH: "อื่นๆ",
  }
}

const DOCUMENTARY = {
  STATUS: {
    READY: "Ready",
    INPROGRESS: "InProgress",
    REJECTED: "Rejected"
  },
  FOLDER_TYPE: {
    DOCUMENTARY: 1,
    CERTIFICATE: 2,
    WARRANRY_DOCUMENTARY: 3,
  }
}

const CUSTOMER_TRAINED_TIER = {
  GOLD: {
    TEXT: 'Gold',
  },
  SILVER: {
    TEXT: 'Silver',
  },
  BRONZE: {
    TEXT: 'Bronze',
  }
}

const COIL_TRANSFER_CONFIRM_TYPE = {
  NO_APPROVE: 'no_approve',
  APPROVE: 'approve',
}

const PROJECT_DOCUMENT = {
  CERTIFICATE_SETTING_TYPE: {
    PRE_POST: 1,
    PRE: 2,
    POST: 3,
  },
  LOG_CATEGORY: {
    WARRANTY_TEMPLATE: 'WarrantyTemplate',
  },
  INFORMATION_STATUS: {
    NONE: 'None',
    REQUESTING: 'Requesting',
    APPROVED: 'Approved',
  }
}

const WATERMARK_TEMPALTE = {
  'Warranty Documentary': 1,
  'Post-Certificate': 2,
  'Pre-Certificate': 3,
  'Warranty Template': 4,
}

const WARRANTY_QUESTION_TYPE = {
  RADIO: 1,
  INPUT: 2,
  TEXTAREA: 3,
  SELECT: 4
}
// CR: 1497
const SPECIAL_SEGMENT = [
  {
    EN: 'Farm & Cattle',
    TH: 'ฟาร์ม & ปศุสัตว์'
  }
]

const DISCOUNT_VOUCHER_MESSAGE = {
  CODE_INVALID: {
    MESSAGE: 'The code is invalid.',
    STATUS: '-4',
  },
  USER_CAN_NOT_USE_CODE: {
    MESSAGE: 'Users cannot use this code.',
    STATUS: '-5',
  },
  NO_M3: {
    MESSAGE: 'There is no M3 product group that can be used for this voucher.',
    STATUS: '-3',
    STATUS_OTHER: '-6',
  },
}
const LETTER_LANG = [
  {
    lang: 'EN',
  },
  {
    lang: 'TH',
  },
]
const DEALER_RECORD_TYPE = {
  MAIN_ACCOUNT: 'Main Account'
}


const AD_CERT_STATUS = {
  LASTEST: 'latest',
};

const CERTIFICATE_LETTER = {
  DOC_NO_FORMAT: `BSAD Certificate [project_name] [running_number]`
}

const SF_CONTACT_OCCUPATION = [
  { value: 'Architect', label: 'Architect' },
  { value: 'Building Owner', label: 'Building Owner' },
  { value: 'Contractor', label: 'Contractor' },
  { value: 'Engineer', label: 'Engineer' },
  { value: 'Home Owner', label: 'Home Owner' },
  { value: 'Interior Designer', label: 'Interior Designer' },
  { value: 'Other', label: 'Other' },
  { value: 'Project Owner', label: 'Project Owner' },
  { value: 'Rollformer Owner', label: 'Rollformer Owner' },
  { value: 'Rollformer Staff', label: 'Rollformer Staff' },
  { value: 'Student', label: 'Student' }
];

const SELL_STATUS = {
  BUY: 'Buy',
  NOT_BUY: 'Not Buy',
}

const NOT_BUY_REASON = {
  FULL_STOCK: 'full_stock',
  NOT_DECIDED: 'not_decided',
  HQ_ORDER: 'hq_order',
  USE_EXTERNAL_STEEL: 'use_external_steel',
  BUY_FROM_OTHER: 'buy_from_other',
  HAS_DEBT: 'has_debt',
}

const NOT_BUY_REASON_TH_LABEL = {
  FULL_STOCK: 'ยังมีสินค้า Stock เต็ม',
  NOT_DECIDED: 'ยังไม่ตัดสินใจ หรือ คนตัดสินใจไม่อยู่',
  HQ_ORDER: 'ส่วนกลาง สำนักงานใหญ่ สั่งซื้อ',
  USE_EXTERNAL_STEEL: 'ใช้เหล็กนอก ไม่ค่อยมีงานบลูสโคป ซื้อแผ่นตัด',
  BUY_FROM_OTHER: 'ซื้อม้วนบลูสโคป หรือ จิงโจ้เหล็ก จากช่องทางอื่น',
  HAS_DEBT: 'มีหนี้ค้างชำระ',
}

const NOT_BUY_REASON_EN_LABEL = {
  FULL_STOCK: 'Still have full stock',
  NOT_DECIDED: 'Not decided yet / Decision maker unavailable',
  HQ_ORDER: 'Ordered by headquarters',
  USE_EXTERNAL_STEEL: 'Uses non-BlueScope steel / rare BlueScope project',
  BUY_FROM_OTHER: 'Buys BlueScope coil or Jingjo steel from other channels',
  HAS_DEBT: 'Has outstanding debt',
}

const ISO_WALL = {
  HAVE: 'มี',
  NOT_HAVE: 'ไม่มี',
}

const ACCOUNT_INFO_FIELD = {
  HAS_ISO_WALL: 'hasIsoWall',
  SANDWICH_MACHINE_COUNT: 'sandwichMachineCount',
}

const VEHICLE_TYPE = {
  FOUR_WHEEL: '4_wheel',
  SIX_WHEEL: '6_wheel',
  TEN_WHEEL: '10_wheel',
  TRAILER: 'trailer',
}

const TEAM_TYPE = {
  STORE_MANAGER: 'store_manager',
  SALES: 'sales',
}

const SALES_GUIDELINE_ANSWER_TYPE = {
  FREE_TEXT: 'free_text',
  DROPDOWN: 'dropdown',
  NUMBER: 'number',
}

const NOT_BUY_REASON_LABEL_MAP = {
  [NOT_BUY_REASON.FULL_STOCK]: NOT_BUY_REASON.FULL_STOCK,
  [NOT_BUY_REASON.NOT_DECIDED]: NOT_BUY_REASON.NOT_DECIDED,
  [NOT_BUY_REASON.HQ_ORDER]: NOT_BUY_REASON.HQ_ORDER,
  [NOT_BUY_REASON.USE_EXTERNAL_STEEL]: NOT_BUY_REASON.USE_EXTERNAL_STEEL,
  [NOT_BUY_REASON.BUY_FROM_OTHER]: NOT_BUY_REASON.BUY_FROM_OTHER,
  [NOT_BUY_REASON.HAS_DEBT]: NOT_BUY_REASON.HAS_DEBT,
  [NOT_BUY_REASON_EN_LABEL.FULL_STOCK]: NOT_BUY_REASON.FULL_STOCK,
  [NOT_BUY_REASON_EN_LABEL.NOT_DECIDED]: NOT_BUY_REASON.NOT_DECIDED,
  [NOT_BUY_REASON_EN_LABEL.HQ_ORDER]: NOT_BUY_REASON.HQ_ORDER,
  [NOT_BUY_REASON_EN_LABEL.USE_EXTERNAL_STEEL]: NOT_BUY_REASON.USE_EXTERNAL_STEEL,
  [NOT_BUY_REASON_EN_LABEL.BUY_FROM_OTHER]: NOT_BUY_REASON.BUY_FROM_OTHER,
  [NOT_BUY_REASON_EN_LABEL.HAS_DEBT]: NOT_BUY_REASON.HAS_DEBT,
  [NOT_BUY_REASON_TH_LABEL.FULL_STOCK]: NOT_BUY_REASON.FULL_STOCK,
  [NOT_BUY_REASON_TH_LABEL.NOT_DECIDED]: NOT_BUY_REASON.NOT_DECIDED,
  [NOT_BUY_REASON_TH_LABEL.HQ_ORDER]: NOT_BUY_REASON.HQ_ORDER,
  [NOT_BUY_REASON_TH_LABEL.USE_EXTERNAL_STEEL]: NOT_BUY_REASON.USE_EXTERNAL_STEEL,
  [NOT_BUY_REASON_TH_LABEL.BUY_FROM_OTHER]: NOT_BUY_REASON.BUY_FROM_OTHER,
  [NOT_BUY_REASON_TH_LABEL.HAS_DEBT]: NOT_BUY_REASON.HAS_DEBT,
}

export const ENUM = {
  SEGMENT_BUILDING,
  CUSTOMER_TRAINED_TIER,
  DOCUMENTARY,
  CUSTOMER_TYPE,
  UPLOAD_PATH,
  UPLOAD_PATH_FOLDER,
  CMS_TYPE,
  STATUS_ACTIVE,
  DATA_TYPE,
  ORDER_INQUIRY_STATUS,
  CUSTOMER_CONTACT_CHANNEL,
  COUNTRY,
  COUNTRY_TYPE,
  REWARD_STOCK_TYPE,
  USER_ROLE,
  CUSTOMER_ROLE_TYPE,
  ADMIN_ROLE,
  PROFILE_TYPE_UNIT,
  DOWNLOAD_PATH,
  COIL_TRANSFER_CONFIRM_TYPE,
  PROJECT_DOCUMENT,
  WATERMARK_TEMPALTE,
  WARRANTY_QUESTION_TYPE,
  SPECIAL_SEGMENT,
  DISCOUNT_VOUCHER_MESSAGE,
  LETTER_LANG,
  DEALER_RECORD_TYPE,
  AD_CERT_STATUS,
  CERTIFICATE_LETTER,
  SF_CONTACT_OCCUPATION,
  SELL_STATUS,
  NOT_BUY_REASON,
  NOT_BUY_REASON_TH_LABEL,
  NOT_BUY_REASON_EN_LABEL,
  ISO_WALL,
  ACCOUNT_INFO_FIELD,
  VEHICLE_TYPE,
  TEAM_TYPE,
  SALES_GUIDELINE_ANSWER_TYPE,
  NOT_BUY_REASON_LABEL_MAP,
}